import React, {FC} from "react"
import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import CultureHubNotificationImage from "@irati/ui/images/culturehub-notification.svg"
import {H3} from "@irati/ui/src/Typography"
import Spacing from "@irati/ui/src/Spacing"
import Button from "@irati/ui/src/Button"
import cultureHubTracking from "@irati-tracking/homepage/cultureHub"
import {useCultureHubStore} from "../../../stores/hooks"

interface Props {
  onClick: () => void
}

const NotificationConfirmation: FC<Props> = ({onClick}) => {
  const {dispatch} = useCultureHubStore()

  const resetToPrevStep = () => {
    cultureHubTracking.clickCultureHubCta("culturehub", "notify_all_cancel")
    dispatch({
      type: "SET_MODAL_STATE",
      payload: {
        modalState: undefined
      }
    })
    dispatch({
      type: "SET_NOTIFICATION",
      payload: {
        isNotificationChecked: false
      }
    })
  }

  return (
    <>
      <Flex direction="column" gap={1.5} alignItems="center" justifyContent="center">
        <img src={CultureHubNotificationImage} alt="culture-hub-notification-image" />
        <H3>
          <FormattedMessage id="culturehub.companyNews.edit.confirmationModal.title" />
        </H3>
      </Flex>
      <Spacing marginTop={2}>
        <Flex alignItems="center" justifyContent="flex-end" gap={1}>
          <Button onClick={resetToPrevStep}>
            <FormattedMessage id="platform.button.cancel" />
          </Button>
          <Button primary onClick={onClick}>
            <FormattedMessage id="platform.globalLogin.fields.button.confirm" />
          </Button>
        </Flex>
      </Spacing>
    </>
  )
}

export default NotificationConfirmation
